"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslations } from "next-intl";
import { ComponentProps } from "react";
import TitleH5 from "../../fonts/TitleH5";
import MainLink from "../../navigation/MainLink";
import AdditionalObject from "./AdditionalObject";
import AdditionalPartner from "./AdditionalPartner";
import BasicFormData from "./BasicFormData";

interface FormDataProps {
  orderHref: ComponentProps<typeof MainLink>["href"];
}

const FormData = ({ orderHref }: FormDataProps) => {
  const t = useTranslations("common");

  return (
    <div className="gap m-auto flex w-full max-w-xl flex-col gap-4">
      <BasicFormData
        companyName={"companyName"}
        salutation={"salutation"}
        firstName={"firstName"}
        lastName={"lastName"}
        email={"email"}
        phone={"phone"}
        street={"street"}
        houseNumber={"houseNumber"}
        postalCode={"postalCode"}
        city={"city"}
        message={"message"}
      />

      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="item-1">
          <AccordionTrigger className="px-0 py-0">
            <TitleH5 title={t("additionalPartner")} />
          </AccordionTrigger>
          <AccordionContent className="flex flex-col gap-4 text-balance">
            <AdditionalPartner
              salutation={"salutation"}
              companyName={"companyName"}
              firstName={"firstName"}
              lastName={"lastName"}
              email={"email"}
              phone={"phone"}
            />
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="item-1">
          <AccordionTrigger className="px-0 py-0">
            <TitleH5 title={t("additionalObject")} />
          </AccordionTrigger>
          <AccordionContent className="flex flex-col gap-4 text-balance">
            <AdditionalObject
              street={"street"}
              houseNumber={"houseNumber"}
              postalCode={"postalCode"}
              city={"city"}
            />
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="flex flex-col items-center">
        <MainLink
          className="max-sm:w-full"
          href={orderHref}
          title={t("bindingOrder")}
        />
      </div>
    </div>
  );
};

export default FormData;
